import './About.css';

function About() {
    
  
    return (
      <div className =  'About' >

        <div className = 'About_title '>
          <h1>About</h1>
       </div>

        <div className = 'About_container'>
          <div className = 'About_paragraph'> 
            <p>Hello! My name is Dion. I'm a graduate of the University of Georgia, where
              I obtained a degree in Computer Science with a certifcate in Applied Data Science. At the University of Georgia, I learned about topics such as 
              cloud computing, web development, and machine learning. With the knowledge I obtained from the University of Georgia, I was eager to
              pursue a career in software development. Right now, I work as an 
              Application Developer at Georgia Power Company.
            </p>
            {/* <p>🔭 I’m currently working....</p> */}
            <p>🌱 I’m currently learning Powershell Script and C#</p>
            <p>🎮 I'm interested in video games and 3D printing.</p>
          </div>
        </div>
      </div>
    );
}  
  
  export default About;
